import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ModalOptionsConfig, ModalService } from '../../../../nz-modal-service/modal.service';
import { EditTransactionLimitModalComponent } from '../edit-transaction-limit-modal/edit-transaction-limit-modal.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { AppConfig } from '../../../../../../shared/config/app-config';

@Component({
  selector: 'app-daily-limit-warning',
  templateUrl: './daily-limit-warning.component.html',
  styleUrls: ['./daily-limit-warning.component.scss']
})
export class DailyLimitWarningComponent implements OnInit {

  // formatOne = (percent: number): string => `Used:\n ${percent}`;
 
  @Input() dailyWebTransactionLimit: number;
  @Input() maxTransferLimit: number;
  @Input() dailyAmountTransfered: number;
  @Input() percentage: number;
  @Input() transactionType: "Transfer" | "Airtime" | "Bill Payment";
  @Output() updateDailyLimit = new EventEmitter();
  breakPoint = 900;
  remainingAmount: number;
  isMobile = false;
	runningModal: NzModalRef;
	showEditTransferLimitModal: boolean;

  constructor(
		public modalService: ModalService,
		public config: AppConfig
  ) { }

  ngOnInit(): void {
		this.showEditTransferLimitModal = this.config.SHOW_TRANSFER_LIMIT_MODAL;
    this.remainingAmount = this.dailyWebTransactionLimit - this.dailyAmountTransfered;
    this.setMobile(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event): void {
    this.setMobile(window.innerWidth);
  }

  setMobile(browserWidth: number) {
    this.isMobile = browserWidth <= this.breakPoint;
  }

  createEditTansferLimitModal() {
		const modalData = {
			isMobile: this.isMobile,
			maxDailyLimit: this.maxTransferLimit
		};
		const config = new ModalOptionsConfig();
		config.className = 'moniepoint-dialog';
		config.nzMaskClosable = true;
		config.nzComponentParams.data = modalData;
		config.nzComponentParams.callback = (result) => {
      this.updateDailyLimit.emit(result);
		};
		this.runningModal = this.modalService.createModal(EditTransactionLimitModalComponent, config);
	}
}
